// app dependencies
import 'admin/styles/main.scss';

// app
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/en';
import { SENTRY_APP, SENTRY_DSN_ADMIN, SENTRY_RELEASE, sentryDenyUrls } from 'common/sentry';
import { IS_DEVEL } from 'utils/environment';
import Root from 'admin/Root';

// Extend Dayjs with the ISO week plugin
dayjs.extend(isoWeek);
// Enable the relativeTime plugin
dayjs.extend(relativeTime);
// Set the locale to English
dayjs.locale('en');

if (!IS_DEVEL) {
	Sentry.init({
		dsn: SENTRY_DSN_ADMIN,
		integrations: [
			Sentry.browserTracingIntegration({
				enableInp: true,
				shouldCreateSpanForRequest: url => url.startsWith(window.location.origin),
			}),
			Sentry.replayIntegration({
				mutationBreadcrumbLimit: 750,
				mutationLimit: 1500,
				maskAllText: false,
				maskAllInputs: true,
			}),
		],
		tracesSampleRate: process.env.NODE_ENV === 'testing' ? 1 : 0.75,
		replaysSessionSampleRate: 0.01,
		replaysOnErrorSampleRate: 1.0,
		release: SENTRY_RELEASE,
		environment: process.env.NODE_ENV,
		initialScope: { tags: { app: SENTRY_APP.admin } },
		denyUrls: sentryDenyUrls,
	});
}

if (process.env.DEBUG !== undefined) {
	localStorage.setItem('debug', process.env.DEBUG);
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
	// <React.StrictMode>
	<Root />
	// </React.StrictMode>
);
